import { useQuery } from '@tanstack/react-query';
import { getCurrentStore } from '@/lib/api/stores.js';

export function usePrintNodeConfigured(type: 'label' | 'receipt') {
  const storeQuery = useQuery({
    queryKey: ['store-current'],
    queryFn: getCurrentStore,
  });

  const store = storeQuery.data;
  const hasPrintNode =
    type === 'label'
      ? store?.printnodeLabelPrinterId != null
      : store?.printnodeReceiptPrinterId != null;

  return { hasPrintNode, store, isLoading: storeQuery.isLoading };
}
